import API from "../api";
import { apiCallbackTreatment } from "../auxiliary/generalFunctions";

const api = new API();

export default class DiscountReasonsController 
{
    async get() 
    {
        const response = await api.discountReasons().get();
        return apiCallbackTreatment(response);
    }
}